export const toggleId = (list, id) => {
  return list.includes(id) ? list.filter((item) => item !== id) : [...list, id]
}
